import React, { FC } from "react";
import { Outlet } from "react-router-dom";
import { t } from "i18next";

import { PageTitle, Sidebar } from "@components/common";
import { Box, Grid } from "@components/base";

export interface UserLayout {
  noPadding?: boolean;
}

const UserLayout: FC<UserLayout> = ({ noPadding }) => (
  <Grid container>
    <PageTitle title={t("Greenometer")} />

    <Grid size={{ xs: 12, sm: "auto" }}>
      <Sidebar />
    </Grid>
    <Grid flex={{ sm: 1 }} size={{ xs: 12, sm: "auto" }} sx={{ height: "100vh" }}>
      <Box
        padding={noPadding ? 0 : 3}
        overflow="auto"
        maxHeight="100vh"
        height="100%"
      >
        <Outlet />
      </Box>
    </Grid>
  </Grid>
);

export default UserLayout;
